import { render } from "./InvoiceIssuance.vue?vue&type=template&id=689516e6&scoped=true"
import script from "./InvoiceIssuance.vue?vue&type=script&lang=js"
export * from "./InvoiceIssuance.vue?vue&type=script&lang=js"

import "./InvoiceIssuance.vue?vue&type=style&index=0&id=689516e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689516e6"]])

export default __exports__